enum SendButtonType {
    button = 0,
    link = 1,
}

export default SendButtonType;